// import html2canvas from "html2canvas";
// import jsPDF from 'jspdf';


// const exportAsImage = async (el, imageFileName) => {
//     const canvas = await html2canvas(el);
//     const image = canvas.toDataURL("image/png", 1.0);
//     downloadImage(image, imageFileName);
// };


// const exportAsImageDev = async (el) => {
//     const canvas = await html2canvas(el);
//     // const image = canvas.toDataURL("image/png", 1.0);
//     return canvas.toDataURL("image/png", 1.0);
// }


// const downloadImage = (blob, fileName) => {
//     const fakeLink = window.document.createElement("a");
//     fakeLink.style = "display:none;";
//     fakeLink.download = fileName;

//     fakeLink.href = blob;

//     document.body.appendChild(fakeLink);
//     fakeLink.click();
//     document.body.removeChild(fakeLink);

//     fakeLink.remove();
// };

// export const downloadPDF = async (elements, setProgress) => {
//     const pdf = new jsPDF('landscape');
//     // pdf.deletePage(1);
//     elements = elements.filter(el => el !== null);

//     if (elements.length === 0) {
//         console.warn("No elements to export.");
//         return;
//     }

//     const pdfWidth = pdf.internal.pageSize.getWidth();
//     let yOffset = 0;
//     const maxImagesPerPage = 2;
//     const totalElements = elements.length;

//     for (const [index, el] of elements.entries()) {
//         if (el && el.getElement() && document.body.contains(el.getElement())) {
//             const image = await exportAsImageDev(el.getElement());
//             const imgProps = pdf.getImageProperties(image);
//             const ratio = pdfWidth / imgProps.width;
//             const imgHeight = imgProps.height * ratio;

//             if (index > 0 && index % maxImagesPerPage === 0) {
//                 pdf.addPage();
//                 yOffset = 0; // Reset yOffset for new page
//             }

//             pdf.addImage(image, 'PNG', 0, yOffset, pdfWidth, imgHeight);
//             yOffset += imgHeight; // Update yOffset for next image
//         } else {
//             console.warn(`Element at index ${index} is not attached to the document.`);
//         }
//         setProgress(Math.round(((index + 1) / totalElements) * 100));
//     }

//     if (window && window?.flutter_inappwebview) {
//         const blob = pdf.output('blob');

//         const reader = new FileReader();
//         reader.readAsDataURL(blob);
//         reader.onloadend = function () {
//             const base64data = reader.result.split(',')[1];

//             window.flutter_inappwebview.callHandler('downloadFileWithBase64', base64data, 'document.pdf');
//         }
//     }
//     else {
//         pdf.save("document.pdf");
//     }

//     setProgress(0); // Reset progress after completion

// };


// export default exportAsImage;


import html2canvas from "html2canvas";
import jsPDF from 'jspdf';

const exportAsImage = async (el, imageFileName) => {
    const canvas = await html2canvas(el);
    const image = canvas.toDataURL("image/png", 1.0);
    downloadImage(image, imageFileName);
};

const exportAsImageDev = async (el) => {
    const canvas = await html2canvas(el);
    return canvas.toDataURL("image/png", 1.0);
}

// const exportAsImageDev = async (el) => {
//   if (!el) return null;

//   // Store original style
//   const originalStyle = el.getAttribute("style");

//   // Temporarily enlarge for full capture
//   el.style.width = "1200px";
//   el.style.height = "600px";
//   el.style.transform = "scale(1)";
//   el.style.overflow = "visible";

//   // Wait for Chart.js resize
//   await new Promise((r) => setTimeout(r, 500));

//   const canvas = await html2canvas(el, {
//     scale: 2,
//     useCORS: true,
//     backgroundColor: "#ffffff",
//     scrollX: 0,
//     scrollY: 0,
//     windowWidth: 1200,
//     windowHeight: 600,
//   });

//   // Restore original style
//   el.setAttribute("style", originalStyle || "");

//   return canvas.toDataURL("image/png", 1.0);
// };




const downloadImage = (blob, fileName) => {
    const fakeLink = window.document.createElement("a");
    fakeLink.style = "display:none;";
    fakeLink.download = fileName;
    fakeLink.href = blob;
    document.body.appendChild(fakeLink);
    fakeLink.click();
    document.body.removeChild(fakeLink);
    fakeLink.remove();
};

export const downloadPDF = async (elements, setProgress) => {
    elements = elements.filter(el => el !== null);

    if (elements.length === 0) {
        console.warn("No elements to export.");
        return;
    }

    const pdf = new jsPDF('landscape');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const totalElements = elements.length;

    let validImageCount = 0;

    for (const [index, el] of elements.entries()) {
        try {
            const element = el.getElement ? el.getElement() : el;
            
            if (!element) {
                console.warn(`Element at index ${index} is null`);
                continue;
            }

            if (!document.body.contains(element)) {
                console.warn(`Element at index ${index} is not in document`);
                continue;
            }

            console.log(`Capturing element ${index}...`);
            
            const image = await exportAsImageDev(element);
            
            if (!image) {
                console.warn(`Failed to generate image for element ${index}`);
                continue;
            }

            const imgProps = pdf.getImageProperties(image);
            const ratio = pdfWidth / imgProps.width;
            const imgHeight = imgProps.height * ratio;

            // Add new page only if we've already added at least one valid image
            if (validImageCount > 0) {
                pdf.addPage();
            }

            pdf.addImage(image, 'PNG', 0, 0, pdfWidth, imgHeight);
            validImageCount++;
            
            console.log(`Successfully added element ${index} to PDF`);
            
        } catch (error) {
            console.error(`Error processing element ${index}:`, error);
        }
        
        setProgress(Math.round(((index + 1) / totalElements) * 100));
    }

    if (validImageCount === 0) {
        alert("No valid elements could be captured!");
        setProgress(0);
        return;
    }

    if (window && window?.flutter_inappwebview) {
        const blob = pdf.output('blob');
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function () {
            const base64data = reader.result.split(',')[1];
            window.flutter_inappwebview.callHandler('downloadFileWithBase64', base64data, 'document.pdf');
        }
    } else {
        pdf.save("document.pdf");
    }

    setProgress(0);
};

export default exportAsImage;


// import html2canvas from "html2canvas";
// import jsPDF from 'jspdf';

// const exportAsImage = async (el, imageFileName) => {
//     const canvas = await html2canvas(el);
//     const image = canvas.toDataURL("image/png", 1.0);
//     downloadImage(image, imageFileName);
// };

// const exportAsImageDev = async (el) => {
//     const canvas = await html2canvas(el);
//     return canvas.toDataURL("image/png", 1.0);
// }

// const downloadImage = (blob, fileName) => {
//     const fakeLink = window.document.createElement("a");
//     fakeLink.style = "display:none;";
//     fakeLink.download = fileName;
//     fakeLink.href = blob;
//     document.body.appendChild(fakeLink);
//     fakeLink.click();
//     document.body.removeChild(fakeLink);
//     fakeLink.remove();
// };

// export const downloadPDF = async (elements, setProgress) => {
//     elements = elements.filter(el => el !== null);
    
//     if (elements.length === 0) {
//         console.warn("No elements to export.");
//         return;
//     }
    
//     const pdf = new jsPDF('landscape');
//     const pdfWidth = pdf.internal.pageSize.getWidth();
//     const pdfHeight = pdf.internal.pageSize.getHeight();
//     const totalElements = elements.length;
//     let validImageCount = 0;
//     let yOffset = 0;
//     const margin = 5;
//     const maxImageHeight = pdfHeight / 2 - margin;
    
//     console.log(`PDF Dimensions: ${pdfWidth} x ${pdfHeight}`);
    
//     for (const [index, el] of elements.entries()) {
//         try {
//             const element = el.getElement ? el.getElement() : el;
            
//             if (!element) {
//                 console.warn(`Element at index ${index} is null`);
//                 continue;
//             }
            
//             if (!document.body.contains(element)) {
//                 console.warn(`Element at index ${index} is not in document`);
//                 continue;
//             }
            
//             console.log(`Capturing element ${index}...`);
            
//             const image = await exportAsImageDev(element);
            
//             if (!image) {
//                 console.warn(`Failed to generate image for element ${index}`);
//                 continue;
//             }
            
//             const imgProps = pdf.getImageProperties(image);
            
//             // ✅ FIXED: Calculate width-based ratio first
//             const widthRatio = pdfWidth / imgProps.width;
//             let imgHeight = imgProps.height * widthRatio;
//             let imgWidth = pdfWidth;
            
//             // ✅ FIXED: Only scale down if height exceeds max, keep aspect ratio
//             if (imgHeight > maxImageHeight) {
//                 const heightRatio = maxImageHeight / imgProps.height;
//                 imgHeight = maxImageHeight;
//                 imgWidth = imgProps.width * heightRatio;
//             }
            
//             console.log(`Image ${index} - Original: ${imgProps.width}x${imgProps.height}, Scaled: ${imgWidth}x${imgHeight}, yOffset: ${yOffset}, Space left: ${pdfHeight - yOffset}`);
            
//             // ✅ Check if image fits on current page
//             if (yOffset + imgHeight > pdfHeight - margin) {
//                 console.log(`Adding new page for element ${index}`);
//                 pdf.addPage();
//                 yOffset = 0;
//             }
            
//             // ✅ Add image at current Y position
//             pdf.addImage(image, 'PNG', 0, yOffset, imgWidth, imgHeight);
            
//             // ✅ Update Y position for next image
//             yOffset += imgHeight + margin;
//             validImageCount++;
            
//             console.log(`Successfully added element ${index}, new yOffset: ${yOffset}`);
            
//         } catch (error) {
//             console.error(`Error processing element ${index}:`, error);
//         }
        
//         setProgress(Math.round(((index + 1) / totalElements) * 100));
//     }
    
//     if (validImageCount === 0) {
//         alert("No valid elements could be captured!");
//         setProgress(0);
//         return;
//     }
    
//     if (window && window?.flutter_inappwebview) {
//         const blob = pdf.output('blob');
//         const reader = new FileReader();
//         reader.readAsDataURL(blob);
//         reader.onloadend = function () {
//             const base64data = reader.result.split(',')[1];
//             window.flutter_inappwebview.callHandler('downloadFileWithBase64', base64data, 'document.pdf');
//         }
//     } else {
//         pdf.save("document.pdf");
//     }
    
//     setProgress(0);
// };

// export default exportAsImage;

